import type {FilenameSchemaEntry} from "#material-outputs-filenames/types"
import {MATERIAL_THUMBNAIL_TYPE} from "#material-outputs-filenames/types"
import {DataObjectAssignmentType} from "@cm/utils/data-object-assignment"

export const organizationName = "gabriel" as const

const mapsExportOptions: FilenameSchemaEntry["options"] = {
    imageFormatSpelling: {
        jpeg: "jpeg",
        tiff: "tiff",
    },
}

export const schemas: FilenameSchemaEntry[] = [
    // maps exports
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "$MATERIAL_RANGE_NAME$_$MATERIAL_NAME$_$EXPORT_FORMAT$_original",
        exportResolution: "original",
        options: mapsExportOptions,
    },

    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "$MATERIAL_RANGE_NAME$_$MATERIAL_NAME$_$EXPORT_FORMAT$_dpi72",
        exportResolution: "dpi72",
        options: mapsExportOptions,
    },

    // tileable renders
    {
        type: DataObjectAssignmentType.MaterialTileableRender,
        schema: "$MATERIAL_RANGE_NAME$_$MATERIAL_NAME$_Tileable_$WIDTH_CM$x$HEIGHT_CM$cm.$IMAGE_FORMAT$",
        imageResolution: "original",
    },

    // thumbnails
    ...MATERIAL_THUMBNAIL_TYPE.map(
        (type): FilenameSchemaEntry => ({
            type,
            schema: "$MATERIAL_RANGE_NAME$_$MATERIAL_NAME$.$IMAGE_FORMAT$",
            imageResolution: "original",
        }),
    ),
]
